import { connect } from "react-redux";
import PropTypes from "prop-types";
import { SETTINGS } from "APP_ROOT/constants";
import { USER } from "MODULES/users/constants";

export default connect(state => ({
  currentUser: state.session && state.session.get(USER).toJS(),
  settings:
    state.session &&
    state.session.get(SETTINGS) &&
    state.session.get(SETTINGS).toJS()
}));

export const WithCurrentUser = {
  currentUser: PropTypes.shape({
    active: PropTypes.bool,
    buying_limit: PropTypes.number,
    can_override_listing: PropTypes.bool,
    can_release_shipment: PropTypes.bool,
    created_at: PropTypes.string.isRequired,
    created_by: PropTypes.shape({
      id: PropTypes.number,
      full_name: PropTypes.string
    }),
    created_by_id: PropTypes.number,
    email: PropTypes.string.isRequired,
    first_name: PropTypes.string.isRequired,
    full_name: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    last_name: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
    manager: PropTypes.bool,
    next_record_id: PropTypes.number,
    po_approval_role: PropTypes.string,
    previous_record_id: PropTypes.number,
    role: PropTypes.string.isRequired,
    updated_at: PropTypes.string.isRequired,
    updated_by: PropTypes.shape({
      id: PropTypes.number,
      full_name: PropTypes.string
    }),
    updated_by_id: PropTypes.number
  }),
  settings: PropTypes.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/session/decorators/withCurrentUser.js